import { Button } from "@/components/ui/button";
import { Phone, ChevronDown } from "lucide-react";

const HERO_IMAGE = "https://images.unsplash.com/flagged/photo-1566838616631-f2618f74a6a2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxtb2Rlcm4lMjBzb2xhciUyMHBhbmVscyUyMG9uJTIwcm9vZiUyMGhvbWV8ZW58MHx8fHwxNzc1ODMzNDM4fDA&ixlib=rb-4.1.0&q=85";

const HeroSection = () => {
  const handleScroll = (href) => {
    const element = document.querySelector(href);
    if (element) {
      const offset = 80;
      const top = element.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  };

  return (
    <section
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      data-testid="hero-section"
    >
      {/* Background Image */}
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${HERO_IMAGE})` }}
        data-testid="hero-background"
      />
      
      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#29383d]/40 via-[#29383d]/50 to-[#29383d]/60" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 text-center py-32">
        <div className="animate-fade-in-up">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8">
            <span className="w-2 h-2 bg-[#5abb3d] rounded-full animate-pulse" />
            <span className="text-white/90 text-sm font-medium tracking-wide uppercase">
              Operativi in tutto il Veneto
            </span>
          </div>

          {/* Main Title */}
          <h1 className="font-outfit text-4xl sm:text-5xl lg:text-6xl font-bold text-white tracking-tight mb-6">
            Soluzioni Energetiche
            <br />
            <span className="text-[#5abb3d]">per la Tua Casa</span>
          </h1>

          {/* Subtitle */}
          <p className="text-lg sm:text-xl text-white/80 max-w-2xl mx-auto mb-10 leading-relaxed">
            Specializzati in impianti di climatizzazione, caldaie, fotovoltaico e ristrutturazione tetti. 
            Pronto intervento elettrico e idraulico 24/7 in tutto il Veneto.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button
              onClick={() => handleScroll("#preventivo")}
              className="bg-[#5abb3d] hover:bg-[#4a9a32] text-white rounded-full px-8 py-6 text-lg font-semibold transition-all hover:-translate-y-1 hover:shadow-xl"
              data-testid="hero-cta-preventivo"
            >
              Richiedi Preventivo Gratuito
            </Button>
            <a
              href="tel:+393292656988"
              className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/30 text-white rounded-full px-8 py-4 font-semibold hover:bg-white/20 transition-all"
              data-testid="hero-cta-call"
            >
              <Phone className="w-5 h-5" />
              Chiama Ora
            </a>
          </div>

          {/* Trust indicators */}
          <div className="mt-16 flex flex-wrap items-center justify-center gap-8 text-white/70">
            <div className="flex items-center gap-2">
              <span className="text-3xl font-bold text-white">15+</span>
              <span className="text-sm">Anni di<br/>Esperienza</span>
            </div>
            <div className="w-px h-10 bg-white/30 hidden sm:block" />
            <div className="flex items-center gap-2">
              <span className="text-3xl font-bold text-white">500+</span>
              <span className="text-sm">Clienti<br/>Soddisfatti</span>
            </div>
            <div className="w-px h-10 bg-white/30 hidden sm:block" />
            <div className="flex items-center gap-2">
              <span className="text-3xl font-bold text-white">24/7</span>
              <span className="text-sm">Pronto<br/>Intervento</span>
            </div>
          </div>
        </div>

        {/* Scroll indicator */}
        <button
          onClick={() => handleScroll("#servizi")}
          className="absolute bottom-8 left-1/2 -translate-x-1/2 text-white/60 hover:text-white transition-colors animate-bounce z-20 p-2"
          data-testid="scroll-indicator"
          aria-label="Scorri verso il basso"
        >
          <ChevronDown className="w-8 h-8 pointer-events-none" />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
